export interface NotificationData {
    image: string;
    title: string;
    body: string;
    type: number;
    order_id: string;
    table_number : string;
    table_id : string;
    table_status:string;
}

export interface NotificationsModel {
  id: string;
  data: NotificationData;
  repetition_count: number
  read: boolean;
  created_at: string;
  assigned_to:string;
  status:{key:number,value:NotificationStatusEnum};
}


export enum NotificationStatusEnum{
  PENDING = 1,
  ASSIGNED = 2,
  DONE = 3
}